module.exports = __webpack_public_path__ + "img/fve_logo.92966966.png";